export interface Anime {
  id: number;
  title: string;
  titleJa: string;
  coverImage: string;
  category: string;
  tags: string[];
  rating: number;
  episodeCount: number;
  currentEpisode: number;
  status: '连载中' | '已完结' | '未开播';
  description: string;
  releaseDate: string;
  updateDay: string;
  studio: string;
  director: string;
  views: number;
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
}

export const animeList: Anime[] = [
  {
    id: 1,
    title: '鬼灭之刃 柱训练篇',
    titleJa: '鬼滅の刃 柱稽古編',
    coverImage: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20anime%20style%20key%20visual%20with%20swordsman%20in%20traditional%20Japanese%20outfit%2C%20dark%20night%20background%20with%20cherry%20blossoms%2C%20dramatic%20lighting%2C%20anime%20art%20style%2C%20high%20contrast%2C%20cinematic%20composition&width=600&height=800&seq=anime-cover-01&orientation=portrait',
    category: '日漫',
    tags: ['热血', '战斗', '奇幻', '少年'],
    rating: 9.7,
    episodeCount: 8,
    currentEpisode: 5,
    status: '连载中',
    description: '在经历了无限城之战后，炭治郎一行人开始了严酷的柱训练。每位柱都以独特的方式训练队员们，为了迎接与无惨的最终决战做准备。本季将展现各柱的过去与决心，以及炭治郎等人突破自我的成长。',
    releaseDate: '2024-05',
    updateDay: '每周日',
    studio: 'ufotable',
    director: '外崎春雄',
    views: 12500000,
    isHot: true,
    isNew: true,
    isRecommended: true,
  },
  {
    id: 2,
    title: '咒术回战 第二季',
    titleJa: '呪術廻戦 第2期',
    coverImage: 'https://readdy.ai/api/search-image?query=Jujutsu%20Kaisen%20anime%20key%20visual%20with%20dark%20hair%20sorcerer%20in%20school%20uniform%2C%20purple%20energy%20effects%2C%20urban%20Tokyo%20night%20background%2C%20anime%20art%20style%2C%20dynamic%20action%20pose&width=600&height=800&seq=anime-cover-02&orientation=portrait',
    category: '日漫',
    tags: ['战斗', '奇幻', '校园', '暗黑'],
    rating: 9.6,
    episodeCount: 23,
    currentEpisode: 23,
    status: '已完结',
    description: '怀玉篇与涩谷事变篇的完整呈现。从五条悟与夏油杰的过去，到涩谷发生的惊天巨变，咒术世界的秩序被彻底颠覆。虎杖悠仁面临着前所未有的挑战。',
    releaseDate: '2023-07',
    updateDay: '已完结',
    studio: 'MAPPA',
    director: '朴性厚',
    views: 28900000,
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 3,
    title: '时光代理人 第二季',
    titleJa: '時光代理人 第二季',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20key%20visual%20with%20two%20young%20men%20in%20modern%20clothing%2C%20time%20travel%20theme%2C%20mysterious%20atmosphere%2C%20city%20background%20at%20sunset%2C%20anime%20art%20style%2C%20emotional%20expression&width=600&height=800&seq=anime-cover-03&orientation=portrait',
    category: '国漫',
    tags: ['悬疑', '奇幻', '剧情', '原创'],
    rating: 9.5,
    episodeCount: 12,
    currentEpisode: 12,
    status: '已完结',
    description: '时光照相馆的秘密被揭开，程小时和陆光面对更加复杂的时空谜题。每一次进入照片都意味着改变命运的可能，但代价也愈发沉重。',
    releaseDate: '2023-07',
    updateDay: '已完结',
    studio: '澜映画',
    director: '李豪凌',
    views: 8700000,
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 4,
    title: '葬送的芙莉莲',
    titleJa: '葬送のフリーレン',
    coverImage: 'https://readdy.ai/api/search-image?query=Frieren%20anime%20key%20visual%20with%20elf%20mage%20girl%20in%20white%20robe%2C%20fantasy%20landscape%20with%20green%20fields%20and%20blue%20sky%2C%20gentle%20and%20wistful%20atmosphere%2C%20anime%20art%20style%2C%20beautiful%20scenery&width=600&height=800&seq=anime-cover-04&orientation=portrait',
    category: '日漫',
    tags: ['奇幻', '冒险', '治愈', '寿命论'],
    rating: 9.8,
    episodeCount: 28,
    currentEpisode: 28,
    status: '已完结',
    description: '打倒魔王后的勇者队伍中，长寿的精灵魔法使芙莉莲，在伙伴们相继离世后，踏上了"了解人类"的旅程。一段关于时间、记忆与羁绊的温馨故事。',
    releaseDate: '2023-09',
    updateDay: '已完结',
    studio: 'MADHOUSE',
    director: '斋藤圭一郎',
    views: 32100000,
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 5,
    title: '伍六七之暗影宿命',
    titleJa: '伍六七之暗影宿命',
    coverImage: 'https://readdy.ai/api/search-image?query=Scissor%20Seven%20Chinese%20anime%20key%20visual%20with%20assassin%20holding%20scissors%2C%20comedy%20action%20style%2C%20tropical%20island%20background%2C%20anime%20art%20style%2C%20vibrant%20colors&width=600&height=800&seq=anime-cover-05&orientation=portrait',
    category: '国漫',
    tags: ['喜剧', '战斗', '热血', '治愈'],
    rating: 9.4,
    episodeCount: 10,
    currentEpisode: 10,
    status: '已完结',
    description: '小鸡岛上暗流涌动，伍六七的真实身份逐渐浮出水面。面对斯特国与玄武国的双重威胁，阿七将做出改变命运的选择。',
    releaseDate: '2023-01',
    updateDay: '已完结',
    studio: '小疯映画',
    director: '何小疯',
    views: 15600000,
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 6,
    title: '我推的孩子 第二季',
    titleJa: '【推しの子】 第2期',
    coverImage: 'https://readdy.ai/api/search-image?query=Oshi%20no%20Ko%20anime%20key%20visual%20with%20idol%20characters%20on%20stage%2C%20spotlight%20effects%2C%20entertainment%20industry%20theme%2C%20anime%20art%20style%2C%20glamorous%20and%20dramatic&width=600&height=800&seq=anime-cover-06&orientation=portrait',
    category: '日漫',
    tags: ['偶像', '悬疑', '剧情', '演艺圈'],
    rating: 9.3,
    episodeCount: 13,
    currentEpisode: 8,
    status: '连载中',
    description: '舞台剧篇正式开幕！阿库亚和露比各自在演艺之路上前进，而隐藏在娱乐圈背后的真相也正一步步被揭开。',
    releaseDate: '2024-07',
    updateDay: '每周三',
    studio: '动画工房',
    director: '平牧大辅',
    views: 18200000,
    isHot: true,
    isNew: true,
    isRecommended: true,
  },
  {
    id: 7,
    title: '天官赐福 第二季',
    titleJa: '天官賜福 第二季',
    coverImage: 'https://readdy.ai/api/search-image?query=Heaven%20Official%20Blessing%20donghua%20key%20visual%20with%20elegant%20man%20in%20white%20traditional%20Chinese%20robe%2C%20ancient%20Chinese%20palace%20background%2C%20ethereal%20atmosphere%2C%20anime%20art%20style%2C%20soft%20lighting&width=600&height=800&seq=anime-cover-07&orientation=portrait',
    category: '国漫',
    tags: ['古风', '奇幻', '剧情', '仙侠'],
    rating: 9.6,
    episodeCount: 12,
    currentEpisode: 12,
    status: '已完结',
    description: '谢怜与花城继续探寻八百年前的真相，天庭与鬼市的纷争愈演愈烈。一段跨越八百年的执念与守护，终将揭晓。',
    releaseDate: '2023-10',
    updateDay: '已完结',
    studio: '绘梦动画',
    director: '李豪凌',
    views: 21300000,
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 8,
    title: '迷宫饭',
    titleJa: 'ダンジョン飯',
    coverImage: 'https://readdy.ai/api/search-image?query=Delicious%20in%20Dungeon%20anime%20key%20visual%20with%20adventurers%20cooking%20monsters%20in%20dungeon%2C%20fantasy%20setting%2C%20food%20theme%2C%20anime%20art%20style%2C%20warm%20and%20funny%20atmosphere&width=600&height=800&seq=anime-cover-08&orientation=portrait',
    category: '日漫',
    tags: ['美食', '奇幻', '冒险', '喜剧'],
    rating: 9.4,
    episodeCount: 24,
    currentEpisode: 24,
    status: '已完结',
    description: '在迷宫里，冒险者莱欧斯一行人为了救回被红龙吃掉的妹妹，决定一边打怪一边烹饪魔物。用美食征服迷宫，一部让人垂涎欲滴的奇幻美食番！',
    releaseDate: '2024-01',
    updateDay: '已完结',
    studio: 'TRIGGER',
    director: '宫岛善博',
    views: 14500000,
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 9,
    title: '反派初始化',
    titleJa: '反派初始化',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20key%20visual%20with%20antihero%20character%20in%20modern%20urban%20setting%2C%20superpower%20theme%2C%20dark%20city%20night%20background%2C%20anime%20art%20style%2C%20cool%20and%20intense&width=600&height=800&seq=anime-cover-09&orientation=portrait',
    category: '国漫',
    tags: ['科幻', '战斗', '剧情', '反套路'],
    rating: 9.2,
    episodeCount: 16,
    currentEpisode: 10,
    status: '连载中',
    description: '当一个普通人获得了"反派"模板，他的人生彻底改变。在这个超级英雄遍地的世界，做反派才是生存之道。一部颠覆传统的反套路国漫。',
    releaseDate: '2024-04',
    updateDay: '每周五',
    studio: '若森数字',
    director: '刘阔',
    views: 6500000,
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 10,
    title: '我心里危险的东西',
    titleJa: '僕の心のヤバイやつ',
    coverImage: 'https://readdy.ai/api/search-image?query=The%20Dangers%20in%20My%20Heart%20anime%20key%20visual%20with%20middle%20school%20boy%20and%20girl%20in%20school%20uniform%2C%20romantic%20comedy%20theme%2C%20classroom%20background%2C%20anime%20art%20style%2C%20sweet%20and%20youthful&width=600&height=800&seq=anime-cover-10&orientation=portrait',
    category: '日漫',
    tags: ['恋爱', '校园', '喜剧', '日常'],
    rating: 9.3,
    episodeCount: 13,
    currentEpisode: 13,
    status: '已完结',
    description: '患有中二病的少年市川京太郎，与班上的美少女山田杏奈之间发生的酸甜恋爱故事。两个性格迥异的人，在日常相处中逐渐靠近彼此。',
    releaseDate: '2024-01',
    updateDay: '已完结',
    studio: '新锐动画',
    director: '赤城博昭',
    views: 9800000,
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 11,
    title: '雾山五行 犀川幻紫林篇',
    titleJa: '霧山五行 犀川幻紫林篇',
    coverImage: 'https://readdy.ai/api/search-image?query=Fog%20Hill%20of%20Five%20Elements%20Chinese%20donghua%20key%20visual%20with%20martial%20artist%20in%20ink%20wash%20painting%20style%2C%20ancient%20Chinese%20mountain%20background%2C%20traditional%20art%20style%2C%20anime%20art%20with%20Chinese%20painting%20influence&width=600&height=800&seq=anime-cover-11&orientation=portrait',
    category: '国漫',
    tags: ['水墨风', '战斗', '奇幻', '热血'],
    rating: 9.7,
    episodeCount: 4,
    currentEpisode: 3,
    status: '连载中',
    description: '延续第一季的水墨画风，火行闻人翊悬踏上犀川幻紫林之旅。中国传统水墨画风与硬核战斗的完美结合，每一帧都是艺术品。',
    releaseDate: '2024-06',
    updateDay: '每月更新',
    studio: '六道无鱼',
    director: '林魂',
    views: 11200000,
    isHot: true,
    isNew: true,
    isRecommended: true,
  },
  {
    id: 12,
    title: '怪兽8号',
    titleJa: '怪獣8号',
    coverImage: 'https://readdy.ai/api/search-image?query=Kaiju%20No%208%20anime%20key%20visual%20with%20monster%20fighter%20in%20combat%20suit%2C%20giant%20monster%20silhouette%20background%2C%20sci-fi%20military%20theme%2C%20anime%20art%20style%2C%20intense%20action&width=600&height=800&seq=anime-cover-12&orientation=portrait',
    category: '日漫',
    tags: ['科幻', '战斗', '热血', '怪兽'],
    rating: 9.1,
    episodeCount: 12,
    currentEpisode: 12,
    status: '已完结',
    description: '32岁的中年大叔日比野卡夫卡，意外获得了变身怪兽的能力，成为了"怪兽8号"。在怪兽频繁出现的日本，他一边隐藏身份一边加入防卫队对抗怪兽。',
    releaseDate: '2024-04',
    updateDay: '已完结',
    studio: 'Production I.G',
    director: '宫繁之',
    views: 17800000,
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
];

export const categories = [
  { id: 'all', name: '全部', icon: 'ri-apps-line' },
  { id: '日漫', name: '日漫', icon: 'ri-sun-line' },
  { id: '国漫', name: '国漫', icon: 'ri-flag-line' },
  { id: '剧场版', name: '剧场版', icon: 'ri-film-line' },
  { id: 'OVA', name: 'OVA', icon: 'ri-dvd-line' },
];

export const faqList = [
  {
    question: '奶泡动漫是否需要付费？',
    answer: '奶泡动漫目前提供完全免费的在线观看服务。我们致力于为广大动漫爱好者提供高品质的观看体验，所有番剧资源均可免费观看，无需会员注册。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '奶泡动漫支持全平台观看，包括PC端浏览器、平板电脑和手机端。我们的网站采用响应式设计，在不同设备上都能获得流畅的观看体验。推荐使用Chrome或Edge浏览器以获得最佳画质。',
  },
  {
    question: '番剧更新频率是怎样的？',
    answer: '我们会紧随日本和国内的播出时间表，第一时间更新最新的番剧集数。一般来说，连载中的番剧会在日本播出后的24小时内完成中文字幕更新，确保您不错过任何精彩内容。',
  },
  {
    question: '如何找到我想看的番剧？',
    answer: '您可以通过首页的搜索框直接搜索番剧名称，也可以通过分类页面按类别（日漫、国漫、剧场版等）浏览。我们还提供了标签筛选功能，帮助您根据题材类型快速找到感兴趣的番剧。',
  },
  {
    question: '视频画质怎么样？',
    answer: '奶泡动漫所有番剧均提供1080P高清画质，部分热门番剧支持4K超清播放。我们采用先进的视频编码技术，在保证画质的同时兼顾流畅度，让您享受极致的观影体验。',
  },
  {
    question: '可以下载番剧离线观看吗？',
    answer: '目前奶泡动漫主要提供在线观看服务。我们正在开发APP端的离线缓存功能，届时您可以将喜欢的番剧下载到本地，在没有网络的环境中也能畅享动漫。敬请期待！',
  },
];

export const aboutInfo = {
  brandIntro: '奶泡动漫成立于2023年，是一家专注于高品质动漫内容聚合与分发的在线平台。我们汇聚了国内外海量优质番剧资源，致力于为广大动漫爱好者打造一片纯净、便捷的追番乐土。',
  mission: '让每一位动漫爱好者都能轻松找到自己喜爱的作品，享受极致的观影体验。',
  achievements: [
    { value: '5000+', label: '番剧资源' },
    { value: '300万+', label: '月活跃用户' },
    { value: '99.9%', label: '服务可用率' },
    { value: '4.9', label: '用户评分' },
  ],
  features: [
    { title: '海量资源', description: '涵盖日漫、国漫、剧场版、OVA等多种类型，超5000部番剧随心看', icon: 'ri-database-2-line' },
    { title: '高清画质', description: '全站支持1080P高清播放，热门番剧提供4K超清画质选择', icon: 'ri-4k-line' },
    { title: '极速更新', description: '日本播出后24小时内完成中文字幕更新，追番不等待', icon: 'ri-flashlight-line' },
    { title: '纯净体验', description: '无广告干扰、无弹窗骚扰，为你营造沉浸式观影环境', icon: 'ri-shield-check-line' },
  ],
  contact: {
    email: 'contact@naipadongman.com',
    weibo: '@奶泡动漫官方',
    wechat: 'naipadongman',
    qqGroup: '874521369',
  },
};